

export default function getResearchQueryPresets({get}: any): Promise<any> {
  return get(`/comparable-sale-query-presets`, {}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/researchQueryPresets/getResearchQueryPresets.tsx